import axios from "./axios";

export async function fetchOfferSettings() {
  return axios.get(`/offers/settings`);
}

export async function updateOfferSettings(payload) {
  return axios
    .put(`/offers/settings`, { settings: payload })
    .then((response) => response.data)
    .catch((error) => {
      if (error.response) {
        return Promise.reject(error.response.data || { error: "Failed to update offer settings" });
      }
      return Promise.reject({ error: error.message || "Failed to update offer settings" });
    });
}
